<template>
  <main class="clinic-info-page">
    <header class="clinic-info-hero">
      <div>
        <span class="clinic-info-eyebrow">Clinic profile</span>
        <h1>Informasi klinik</h1>
        <p>Lihat identitas klinik dan status langganan dalam satu tampilan.</p>
      </div>
      <span
        class="clinic-info-status"
        :class="data.is_subscribe == 1 ? 'clinic-info-status--active' : 'clinic-info-status--trial'"
      >
        <i :class="data.is_subscribe == 1 ? 'fas fa-check-circle' : 'far fa-clock'"></i>
        {{ data.is_subscribe == 1 ? "Langganan aktif" : "Masa trial" }}
      </span>
    </header>

    <div class="clinic-info-layout">
      <aside class="clinic-profile-card">
        <div class="clinic-profile-card__cover"></div>
        <div class="clinic-profile-card__content">
          <div class="clinic-profile-avatar">
            <img
              src="/images/default-profile.svg"
              alt="Logo klinik"
              @load="onImageLoad()"
            />
            <span class="clinic-profile-avatar__status" title="Klinik aktif"></span>
          </div>
          <span class="clinic-info-eyebrow">Profil klinik</span>
          <h2>{{ regis.clinic_name || "Nama klinik" }}</h2>
          <p><i class="fas fa-map-marker-alt"></i>{{ locationName }}</p>

          <div class="clinic-profile-registration">
            <span class="clinic-profile-registration__icon">
              <i class="far fa-calendar-check"></i>
            </span>
            <div>
              <small>Terdaftar sejak</small>
              <strong>{{ regis.register_date_display || "-" }}</strong>
            </div>
          </div>
        </div>
      </aside>

      <section class="clinic-detail-card">
        <div class="clinic-card-heading">
          <div>
            <span class="clinic-info-eyebrow">Data utama</span>
            <h2>Detail klinik</h2>
            <p>Informasi registrasi yang terhubung dengan akun Medhop.</p>
          </div>
          <span class="clinic-card-heading__icon"><i class="far fa-building"></i></span>
        </div>

        <dl class="clinic-detail-list">
          <div>
            <dt><i class="fas fa-clinic-medical"></i>Nama klinik</dt>
            <dd>{{ regis.clinic_name || "-" }}</dd>
          </div>
          <div>
            <dt><i class="fas fa-map-marked-alt"></i>Wilayah</dt>
            <dd>{{ locationName }}</dd>
          </div>
          <div>
            <dt><i class="far fa-calendar-alt"></i>Tanggal registrasi</dt>
            <dd>{{ regis.register_date_display || "-" }}</dd>
          </div>
          <div>
            <dt><i class="fas fa-box-open"></i>Paket aktif</dt>
            <dd>{{ regis.subscribe_package_name || "-" }}</dd>
          </div>
        </dl>
      </section>

      <aside class="clinic-subscription-card">
        <div class="clinic-card-heading">
          <div>
            <span class="clinic-info-eyebrow">Subscription</span>
            <h2>Status langganan</h2>
          </div>
          <span class="clinic-card-heading__icon clinic-card-heading__icon--teal">
            <i class="fas fa-crown"></i>
          </span>
        </div>

        <div class="clinic-subscription-package">
          <small>Paket saat ini</small>
          <strong>{{ regis.subscribe_package_name || "Belum ada paket" }}</strong>
        </div>

        <div class="clinic-subscription-expiry">
          <span class="clinic-subscription-expiry__value">{{ remainingDays }}</span>
          <div>
            <strong>Hari tersisa</strong>
            <small>Aktif sampai {{ data.display_end_date || "-" }}</small>
          </div>
        </div>

        <div class="clinic-subscription-state">
          <span>Status</span>
          <strong :class="data.is_subscribe == 1 ? 'is-active' : 'is-trial'">
            {{ data.is_subscribe == 1 ? "Berlangganan aktif" : "Masa trial" }}
          </strong>
        </div>

        <button type="button" class="clinic-subscription-button" @click="$router.push('/subscribe/package')">
          <span>{{ data.is_subscribe == 1 ? "Kelola langganan" : "Pilih paket" }}</span>
          <i class="fas fa-arrow-right"></i>
        </button>
      </aside>
    </div>
  </main>
</template>

<script>
import saasModule from "@/core/modules/CrudSaasModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      // Data
      data: [],
      regis:[],
      // Other
      imgLoaded: false,
      // User Access
      btn: false,
    };
  },

  computed: {
    locationName() {
      return [this.regis.city_name, this.regis.province_name]
        .filter(Boolean)
        .join(", ") || "Lokasi belum tersedia";
    },

    remainingDays() {
      const days = Number(this.data.diff_date);
      return Number.isFinite(days) ? Math.max(days, 0) : 0;
    },
  },

  methods: {
    onImageLoad() {
      this.imgLoaded = true;
    },

    // async deleteData() {
    //   let result = await saasModule.delete('billings/' + this.$route.params.id)
    //   // If Deleted
    //   if (result) {
    //     // Redirect To List
    //     this.$router.push('/donors')
    //   }
    // },

    async get() {
      this.data = JSON.parse(localStorage.getItem('tenantconfig'))
    },

    async getRgis() {
      this.regis = await saasModule.get("registrants/" + this.data.registrant_id);
     
    },

    // setActiveButton(){
    //   let access_right_user = window.localStorage.getItem("access_right_display")
    //   let access_right = JSON.parse(access_right_user)

    //   let a
    //   for(a = 0; a < access_right.length; a++){
    //     if(access_right[a] == "2202"){
    //       this.btn = true
    //     }
    //   }
    // },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Info Klinik" },
    ]);

    this.get();
    this.getRgis();
    // this.setActiveButton();
  },
};
</script>

<style lang="scss">
.clinic-info-page {
  --clinic-navy: var(--skin-deep);
  --clinic-blue: var(--skin-primary);
  --clinic-teal: var(--skin-secondary);
  --clinic-border: #e3eaf2;
  color: #1a2433;
}

.clinic-info-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 16px;
  padding: 18px 20px;
  border: 1px solid var(--clinic-border);
  border-radius: 18px;
  background: linear-gradient(110deg, rgba(var(--skin-deep-rgb), 0.08), rgba(var(--skin-secondary-rgb), 0.07));
  box-shadow: 0 9px 24px rgba(var(--skin-deep-rgb), 0.055);
}

.clinic-info-eyebrow {
  display: block;
  margin-bottom: 4px;
  color: var(--clinic-teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.clinic-info-hero h1 {
  margin: 0 0 4px;
  color: #1a2433 !important;
  font-size: 22px !important;
  font-weight: 700;
}

.clinic-info-hero p,
.clinic-card-heading p {
  margin: 0;
  color: #6b7280;
  font-size: 11px;
}

.clinic-info-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 34px;
  padding: 7px 11px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.clinic-info-status--active {
  color: var(--skin-primary);
  border-color: rgba(var(--skin-secondary-rgb), 0.2);
  background: rgba(var(--skin-secondary-rgb), 0.09);
}

.clinic-info-status--trial {
  color: #a9680e;
  border-color: rgba(245, 158, 11, 0.2);
  background: rgba(245, 158, 11, 0.1);
}

.clinic-info-layout {
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr) 300px;
  gap: 16px;
  align-items: stretch;
}

.clinic-profile-card,
.clinic-detail-card,
.clinic-subscription-card {
  overflow: hidden;
  border: 1px solid var(--clinic-border);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 9px 26px rgba(var(--skin-deep-rgb), 0.055);
}

.clinic-profile-card__cover {
  height: 82px;
  background: linear-gradient(135deg, var(--clinic-navy), var(--clinic-blue), var(--clinic-teal));
}

.clinic-profile-card__content {
  padding: 0 17px 17px;
  text-align: center;
}

.clinic-profile-avatar {
  position: relative;
  width: 86px;
  height: 86px;
  margin: -43px auto 12px;
  padding: 7px;
  border: 4px solid #fff;
  border-radius: 24px;
  background: #f5f8fb;
  box-shadow: 0 9px 22px rgba(var(--skin-deep-rgb), 0.13);
}

.clinic-profile-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: contain;
}

.clinic-profile-avatar__status {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 16px;
  height: 16px;
  border: 3px solid #fff;
  border-radius: 50%;
  background: var(--clinic-teal);
}

.clinic-profile-card h2 {
  margin: 0 0 6px;
  color: var(--clinic-navy) !important;
  font-size: 16px !important;
  font-weight: 700;
}

.clinic-profile-card__content > p {
  display: flex;
  min-height: 34px;
  margin: 0 0 15px;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  color: #6b7280;
  font-size: 10px;
  line-height: 1.45;
}

.clinic-profile-card__content > p i {
  margin-top: 2px;
  color: var(--clinic-teal);
}

.clinic-profile-registration {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px;
  text-align: left;
  border: 1px solid var(--clinic-border);
  border-radius: 11px;
  background: #f8fafc;
}

.clinic-profile-registration__icon {
  display: grid;
  width: 33px;
  height: 33px;
  flex: 0 0 33px;
  place-items: center;
  color: var(--clinic-blue);
  border-radius: 9px;
  background: rgba(var(--skin-primary-rgb), 0.08);
}

.clinic-profile-registration small,
.clinic-profile-registration strong {
  display: block;
}

.clinic-profile-registration small {
  color: #8591a2 !important;
  font-size: 8px;
  text-transform: uppercase;
}

.clinic-profile-registration strong {
  color: #334155;
  font-size: 10px;
}

.clinic-detail-card,
.clinic-subscription-card {
  padding: 17px;
}

.clinic-card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 15px;
  padding-bottom: 13px;
  border-bottom: 1px solid #edf1f5;
}

.clinic-card-heading h2 {
  margin: 0 0 3px;
  color: #1a2433 !important;
  font-size: 16px !important;
  font-weight: 700;
}

.clinic-card-heading__icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  color: var(--clinic-blue);
  border-radius: 11px;
  background: rgba(var(--skin-primary-rgb), 0.08);
}

.clinic-card-heading__icon--teal {
  color: var(--clinic-teal);
  background: rgba(var(--skin-secondary-rgb), 0.09);
}

.clinic-detail-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0;
}

.clinic-detail-list > div {
  min-width: 0;
  padding: 11px;
  border: 1px solid var(--clinic-border);
  border-radius: 11px;
  background: #fbfcfe;
}

.clinic-detail-list dt {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #7b8798;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.clinic-detail-list dt i {
  width: 13px;
  color: var(--clinic-teal);
  text-align: center;
}

.clinic-detail-list dd {
  margin: 0;
  overflow: hidden;
  color: #2f4057;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.45;
  text-overflow: ellipsis;
}

.clinic-subscription-package {
  margin-bottom: 11px;
  padding: 11px;
  border: 1px solid var(--clinic-border);
  border-radius: 11px;
  background: #f8fafc;
}

.clinic-subscription-package small,
.clinic-subscription-package strong {
  display: block;
}

.clinic-subscription-package small {
  margin-bottom: 3px;
  color: #8290a2 !important;
  font-size: 8px;
  text-transform: uppercase;
}

.clinic-subscription-package strong {
  color: var(--clinic-navy);
  font-size: 12px;
}

.clinic-subscription-expiry {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-bottom: 11px;
  padding: 12px;
  color: #fff;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--clinic-navy), var(--clinic-blue), var(--clinic-teal));
}

.clinic-subscription-expiry__value {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 18px;
  font-weight: 700;
}

.clinic-subscription-expiry strong,
.clinic-subscription-expiry small {
  display: block;
  color: #fff !important;
}

.clinic-subscription-expiry strong {
  margin-bottom: 3px;
  font-size: 11px;
}

.clinic-subscription-expiry small {
  font-size: 8px;
  opacity: 0.72;
}

.clinic-subscription-state {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding: 0 2px;
  color: #6b7280;
  font-size: 9px;
}

.clinic-subscription-state strong {
  font-size: 9px;
}

.clinic-subscription-state .is-active { color: var(--clinic-teal); }
.clinic-subscription-state .is-trial { color: #a9680e; }

.clinic-subscription-button {
  display: flex;
  width: 100%;
  min-height: 38px;
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--clinic-navy), var(--clinic-blue), var(--clinic-teal));
  box-shadow: 0 7px 16px rgba(var(--skin-primary-rgb), 0.17);
  font-size: 10px;
  font-weight: 700;
}

@media (max-width: 1199.98px) {
  .clinic-info-layout {
    grid-template-columns: 230px minmax(0, 1fr);
  }

  .clinic-subscription-card {
    grid-column: 1 / -1;
  }
}

@media (max-width: 767.98px) {
  .clinic-info-hero {
    align-items: flex-start;
    flex-direction: column;
  }

  .clinic-info-layout {
    grid-template-columns: 1fr;
  }

  .clinic-subscription-card {
    grid-column: auto;
  }
}

@media (max-width: 479.98px) {
  .clinic-detail-list {
    grid-template-columns: 1fr;
  }
}
</style>
